import { render } from "./ref-orders.vue?vue&type=template&id=1e5ea9c2&ts=true"
import script from "./ref-orders.vue?vue&type=script&lang=ts"
export * from "./ref-orders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__